export const enum zIndex {
    vttDisable = -2,
    quizPlayButton = 1,
    backwardForwardInActive,
    quizHeader,
    comments,
    videoPlayer,
    snapshot,
    mainIcons,
    emoji,
    footer,
    mainIconInComplexPortrait,
    poll,
    liveStatus,
    download,
    lockIcon,
    backwardForwardActive,
    fullrate,
    autoPlay,
    vtt,
    tagsFilterPopover,
    markers,
    videoPlayerInFullScreen = 1000000,
    portraitHeader,
    emojiPicker,
    popoverBlurBackground,
    popoverContent,
    maxPopover,
    videoPlayerInPictureInPicture,
    trailer,
    commentAnswer
}

export const enum ContentTypes {
    Vod,
    PlayList
}

export const enum ContentTypesString {
    Vod = "vod",
    PlayList = "playlist"
}

export const enum VideoNumberTypeEnum {
    Archive = 1,
    Vod = 2,
    Clip = 3,
    FutureLive = 4,
    PlayList
}

export const enum QuizTypes {
    Elimination = 1,
    Points = 2
}

export const enum UserQuizStatus {
    participant = "participant",
    viewer = "viewer",
    loser = "loser"
}

export const enum QuestionStatus {
    ANSWER = 1,
    UNANSWER = 2,
    INACTIVE = 3,
    DONE = 4,
    READY
}

export const enum QuizLoginSteps {
    mobileNumber = "mobileNumber",
    otp = "otp"
}

export const enum SettingSections {
    main = "main",
    qualityLevels = "qualityLevels",
    subtitlesSettingMenu = "subtitlesSettingMenu",
    subtitles = "subtitles",
    subtitlesBackgroundColors = "subtitlesBackgroundColors",
    subtitlesTextColors = "subtitlesTextColors",
    multiAudio = "multiAudio"
}

export const enum SubtitleColors {
    black = "سیاه",
    white = "سفید",
    yellow = "زرد",
    blue = "آبی",
    green = "سبز"
}

export const enum SubtitleColorsCode {
    black = "2c2c2c",
    white = "ffffff",
    yellow = "FAD832",
    blue = "027DFF",
    green = "84CC16"
}

export const enum ConditionName {
    showHeader = "showHeader",
    showMain = "showMain",
    showFooter = "showFooter",
    showGif = "showGif",
    showTouchVolumeBrightness = "showTouchVolumeBrightness",
    showBackwardForward = "showBackwardForward",
    showLiveStatus = "showLiveStatus",
    showLiveStatusInComplexPortrait = "showLiveStatusInComplexPortrait",
    showElapsedTime = "showElapsedTime",
    showPoll = "showPoll",
    showFullRate = "showFullRate",
    showTitle = "showTitle",
    showSnapShot = "showSnapShot",
    showInstagramEmoji = "showInstagramEmoji",
    showOnlineViewers = "showOnlineViewers",
    showMultiLivePopover = "showMultiLivePopover",
    showMarkerListPopover = "showMarkerListPopover",
    showFullRatePopover = "showFullRatePopover",
    showAutoPlayPopover = "showAutoPlayPopover",
    showRecommendListPopover = "showRecommendListPopover",
    showSettingPopover = "showSettingPopover",
    showSpeedPopover = "showSpeedPopover",
    showTagsPopover = "showTagsPopover",
    showPersonalMarkerPopover = "showPersonalMarkerPopover",
    showBookmarksPopover = "showBookmarksPopover",
    showChatPopover = "showChatPopover",
    showFeedbackPopover = "showFeedbackPopover",
    showTrailerPopover = "showTrailerPopover",
    showLoginPopover = "showLoginPopover",
    showAutoPlayListTouchIcon = "showAutoPlayListTouchIcon",
    showMultiLive = "showMultiLive",
    showBigReplayIcon = "showBigReplayIcon",
    showReplayIcon = "showReplayIcon",
    showPlayNextIcon = "showPlayNextIcon",
    showAutoPlayToggleIcon = "showAutoPlayToggleIcon",
    showSettingIcon = "showSettingIcon",
    showLikeDislike = "showLikeDislike",
    showBanner = "showBanner",
    showBannerStaticFiles = "showBannerStaticFiles",
    showSpeedIcon = "showSpeedIcon",
    showShareInSetting = "showShareInSetting",
    showPlayListIcon = "showPlayListIcon",
    showPlayListTabTouchscreen = "showPlayListTabTouchscreen",
    showCommentComponent = "showCommentComponent",
    showModuleTitle = "showModuleTitle",
    showProgressbar = "showProgressbar",
    showAgeClassification = "showAgeClassification",
    showChat = "showChat",
    showMiniPlayer = "showMiniPlayer",
    showPictureInPicture = "showPictureInPicture",
    showPersonalMarker = "showPersonalMarker",
    showFeedback = "showFeedback",
    showTabNavigator = "showTabNavigator",
    showBookmark = "showBookmark",
    shareButton = "shareButton",
    showVideoUploadTime = "showVideoUploadTime",
    showVideoViewers = "showVideoViewers",
    showRecommendationList = "showRecommendationList",
    showPlaylist = "showPlaylist",
    show_Chat = "show_Chat",
    showEmojiComplexPortrait = "showEmojiComplexPortrait",
    hidePopovers = "hidePopovers",
    isRaw = "isRaw",
    isParamsPortrait = "isParamsPortrait",
    isComplexPortrait = "isComplexPortrait",
    isComplexDarkModePortrait = "isComplexDarkModePortrait",
    isComplexDesktop = "isComplexDesktop",
    isLandscape = "isLandscape",
    isTouchScreen = "isTouchScreen",
    isTouchScreenPortrait = "isTouchScreenPortrait",
    isTouchScreenLandscape = "isTouchScreenLandscape",
    isActiveElements = "isActiveElements",
    isPlay = "isPlay",
    isFirstPlay = "isFirstPlay",
    isLock = "isLock",
    isIOS = "isIOS",
    isIOSLive = "isIOSLive",
    isLoading = "isLoading",
    isLive = "isLive",
    isLiveParam = "isLiveParam",
    isLiveError = "isLiveError",
    isDarkMode = "isDarkMode",
    isStaticFormat = "isStaticFormat",
    isEnded = "isEnded",
    isAutoPlay = "isAutoPlay",
    isFullScreen = "isFullScreen",
    isGeneral = "isGeneral",
    isValidAddress = "isValidAddress",
    isFetchDetails = "isFetchDetails",
    isAutoQuality = "isAutoQuality",
    isAuth = "isAuth",
    isChildClassification = "isChildClassification",
    isTeenagerClassification = "isTeenagerClassification",
    isYoungClassification = "isYoungClassification",
    isSelectedSubtitle = "isSelectedSubtitle",
    isZarebinSite = "isZarebinSite",
    isUserIdsParamsEqualAll = "isUserIdsParamsEqualAll",
    isMiniPlayer = "isMiniPlayer",
    isFullMobilePortrait = "isFullMobilePortrait",
    isLogin = "isLogin",
    isSpinSettingsIcon = "isSpinSettingsIcon",
    isVttFitHeight = "isVttFitHeight",
    isBookmark = "isBookmark",
    isPressKeySpace = "isPressKeySpace",
    isPressKeyK = "isPressKeyK",
    isPressKeyI = "isPressKeyI",
    isPressKeyF = "isPressKeyF",
    isPressKeyS = "isPressKeyS",
    isPressKeyC = "isPressKeyC",
    isPressKeyArrowRight = "isPressKeyArrowRight",
    isPressKeyArrowLeft = "isPressKeyArrowLeft",
    isPressKeyL = "isPressKeyL",
    isPressKeyN = "isPressKeyN",
    isPressKeyQ = "isPressKeyQ",
    isPressKeyE = "isPressKeyE",
    isPressKeyM = "isPressKeyM",
    isSendTimelineLog = "isSendTimelineLog",
    isReady = "isReady",
    isSplusEnvironment = "isSplusEnvironment",
    isProduction = "isProduction",
    isPaymentSuccess = "isPaymentSuccess",
    isPopoverOpen = "isPopoverOpen",
    isBeforeRequest_Playlist_Chat_Recommendation = "isBeforeRequest_Playlist_Chat_Recommendation",
    isBeforeRequestComments = "isBeforeRequestComments",
    isVisibilityChange = "isVisibilityChange",
    backgroundColorInLightMode = "backgroundColorInLightMode",
    heightScreen = "HeightScreen",
    playByClickPoster = "playByClickPoster",
    hasMarkers = "hasMarkers",
    hasTitle = "hasTitle",
    hasDescription = "hasDescription",
    hasClipboard = "hasClipboard",
    hasTags = "hasTags",
    hasRecommendationList = "hasRecommendationList",
    hasPreviewTime = "hasPreviewTime",
    hasEmojis = "hasEmojis",
    hasEmojiList1Or2 = "hasEmojiList1Or2",
    hasBanner = "hasBanner",
    hasMultiAudio = "hasMultiAudio",
    hasDownloadLinks = "hasDownloadLinks",
    hasStreamLink = "hasStreamLink",
    hasPoll = "hasPoll",
    hasUserIds = "hasUserIds",
    hasAlternativeLives = "hasAlternativeLives",
    hasManualQuality = "hasManualQuality",
    hasSound = "hasSound",
    hasVtt = "hasVtt",
    hasAutoPlay = "hasAutoPlay",
    hasPlayList = "hasPlayList",
    hasXToken = "hasXToken",
    hasMovieDetails = "hasMovieDetails",
    hasMovieContentType = "hasMovieContentType",
    hasMovieReleaseYear = "hasMovieReleaseYear",
    hasSubtitle = "hasSubtitle",
    hasIMDB = "hasIMDB",
    hasSelectedTags = "hasSelectedTags",
    hasInputTagSearch = "hasInputTagSearch",
    hasFullScreenParams = "hasFullScreenParams",
    hasPreviewParams = "hasPreviewParams",
    hasChart = "hasChart",
    hasChartPoints = "hasChartPoints",
    hasOnFinishedParams = "hasOnFinishedParams",
    hasOnSnapshotParams = "hasOnSnapshotParams",
    hasXTokenParamOrSendXToken = "hasXTokenParamOrSendXToken",
    hasUserAvatar = "hasUserAvatar",
    hasUserName = "hasUserName",
    hasUserPhoneNumber = "hasUserPhoneNumber",
    hasScrollElementId = "hasScrollElementId",
    hasSportProvider = "hasSportProvider",
    hasSidebar = "hasSidebar",
    hasTrailer = "hasTrailer",
    hasHParam = "hasHParam",
    hasQuizParams = "hasQuizParams",
    hasPreviewStart = "hasPreviewStart",
    hasPreviewEnd = "hasPreviewEnd",
    hasSubtitles = "hasSubtitles",
    hasHomeButtonClickFlag = "hasHomeButtonClickFlag",
    hasContinuousPlayback = "hasContinuousPlayback",
    hasPermittedLoadedFragment = "hasPermittedLoadedFragment",
    hasAllParams = "hasAllParams",
    hasDefaultMessages = "hasDefaultMessages",
    hasPinMessage = "hasPinMessage",
    hasCommentDefaultMessages = "hasCommentDefaultMessages",
    getRecommendationList = "getRecommendationList",
    getLiveDetailsInIntervals = "getLiveDetailsInIntervals",
    getDetails = "getDetails",
    getMarkers = "getMarkers",
    getPlayList = "getPlayList",
    getUserSetting = "getUserSetting",
    getVideoMetaData = "getVideoMetaData",
    getUserProfile = "getUserProfile",
    firstGetDataIntervalAPI = "firstGetDataIntervalAPI",
    footerPaddingZero = "footerPaddingZero",
    manaulPostAPI = "manaulPostAPI",
    canAccessVideo = "canAccessVideo",
    canAddComment = "canAddComment",
    canShowSubmittedComment = "canShowSubmittedComment",
    canPlayVideo = "canPlayVideo",
    chatEnabled = "chatEnabled",
    trackerEnabled = "trackerEnabled",
    filterLastGif = "filterLastGif",
    instagramEmojiAnimation = "instagramEmojiAnimation",
    handleOverflowHidden = "handleOverflowHidden",
    thresholdOnlineViewers = "thresholdOnlineViewers",

    // *** Quiz Conditions Enums ***
    showQuizPopover = "showQuizPopover",
    showUserStatus = "showUserStatus",
    isQuizStatusEqual1 = "isQuizStatusEqual1",
    isQuizStatusEqual2 = "isQuizStatusEqual2",
    isQuizStatusEqual4 = "isQuizStatusEqual4",
    isQuizEnd = "isQuizEnd",
    isPointsQuiz = "isPointsQuiz",
    hasQuiz = "hasQuiz",
    hasQuizQuestion = "hasQuizQuestion",
    hasChances = "hasChances",
    sendUserTrackerRequest = "sendUserTrackerRequest"
}

export const enum ChatType {
    public,
    private,
    auto
}
